import mapTransforms from './map-transforms.json'

// Radar projection: game world coordinates → the 1024² overview image.
//
// These lived in RadarCanvas.tsx, which meant that file exported two functions and a component —
// enough to break Fast Refresh, and enough that four other modules imported a component file to get
// arithmetic. They are not components; they are the map's coordinate system.

const MAPS = mapTransforms as Record<string, { posX: number; posY: number; scale: number }>
const FALLBACK = { posX: -2476, posY: 3239, scale: 4.4 }

/** Transform for a radar name, including layer radars. de_nuke_lower is decoded from the same
 *  overview as de_nuke (see scripts/cs2-radars.sh), so it shares its transform and the table only
 *  carries the base key — verified: all 78 lower-nuke kills project onto lower geometry.
 *  Looking up "de_nuke_lower" directly misses, and a miss is silent in both directions: one caller
 *  drew nothing on lower, another drew every point through a generic fallback in the wrong place. */
export function transformFor(map: string) {
  return MAPS[map] ?? MAPS[map.replace(/_(lower|upper)$/, '')] ?? FALLBACK
}

/** Game world → canvas pixels. The radar PNGs are 1024², so a transform maps world coords onto
 *  that square and we scale to whatever size we're drawing at. */
export function projector(map: string, size: number) {
  const t = transformFor(map)
  const k = size / 1024
  return (x: number, y: number): [number, number] => [((x - t.posX) / t.scale) * k, ((t.posY - y) / t.scale) * k]
}
